export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-die-three-416fb672bf7ea5c8a982d9338d5c24fc.svg";